
/**
 * @imports
 */
import ExprInterface from './ExprInterface.js';

/**
 * ---------------------------
 * IndependentScopeInterface
 * ---------------------------
 */				

export default class extends ExprInterface {};
